export const OMNICHANNEL_PLANS_MODAL_TITLE = "Omnichannel Inbox";
